import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Company from '../views/app/Company.vue'

Vue.use(VueRouter)

const blocker = (to, from, next) => {
                                      const token = $cookies.get('__fw_token')
                                      //console.log(to, from, next)
                                      if (token) {
                                        store.dispatch('user/getUser').then(
                                          (result) => {
                                            window.drift.identify(result._id, {
                                              email: result.email,
                                              name: result.firstName + ' ' + result.lastName
                                            })
                                            window.drift.load('3fpfc2abuesp')
                                          },
                                          (error) => {}
                                        )
                                        store.dispatch('getCompany').then(
                                          (result) => {
                                            if (result.isMember) {
                                              return next()
                                            } else {
                                              return next('/')
                                            }
                                          },
                                          (error) => {
                                            return next('/')
                                          }
                                        )
                                      } else {
                                        return next('/')
                                      }
                                    }

const checkAuth = (to, from, next) => {
  console.log('IN CHECK AUTH')
  const token = $cookies.get('__fw_token')
  const system = window.location.host.split('.')[0] === 'app'
  if (system && to.path === '/') {
    return next({ name: 'login' })
  }

  if (token && window.location.host !== 'app.feature.watch') {
    //dont check this on marketing page things
    store.dispatch('user/getUser').then(
      (result) => {
        window.drift.identify(result._id, {
          email: result.email,
          name: result.firstName + ' ' + result.lastName
        })
        window.drift.load('3fpfc2abuesp')
        return next()
      },
      (error) => {
        return next()
      }
    )
  } else {
    next()
  }
}

const systemOrCompany = (to, from, next) => {
  const system = window.location.host.split('.')[0] === 'app'
  if (!system && to.path === '/') {
    return next({ name: 'PublicDashboard' })
  }
  return next()
}

const routes = [
  {
    path: '/put-that-cookie-down',
    name: 'WidgetCookie',
    component: () => import(/* webpackChunkName: "widget" */ '../widget/WidgetCookie.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    beforeEnter: blocker,
    meta: { member: true },
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Admin.vue'),
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Dashboard.vue')
      },
      {
        path: 'expired',
        name: 'Expired',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Expired.vue')
      },
      {
        path: 'welcome',
        name: 'OnboardingWelcome',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Onboarding.vue')
      },
      {
        path: 'create-board',
        name: 'CreateBoard',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/board/Create.vue')
      },
      {
        path: 'settings',
        name: 'SettingsLayout',
        component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsLayout.vue'),
        children: [
          {
            path: 'account',
            name: 'SettingsAccount',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsAccount.vue')
          },
          {
            path: 'notifications',
            name: 'SettingsNotifications',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsNotifications.vue')
          },
          {
            path: 'change-password',
            name: 'SettingsChangePassword',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsChangePassword.vue')
          },
          {
            path: 'company',
            name: 'SettingsCompany',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsCompany.vue')
          },
          {
            path: 'team',
            name: 'SettingsTeam',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsTeam.vue')
          },
          {
            path: 'statuses',
            name: 'SettingsStatuses',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsStatuses.vue')
          },
          {
            path: 'billing',
            name: 'SettingsBilling',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsBilling.vue')
          },
          {
            path: 'custom-domain',
            name: 'SettingsCustomDomain',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsCustomDomain.vue')
          },
          {
            path: 'slack',
            name: 'SettingsSlack',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsSlack.vue')
          },
          {
            path: 'intercom',
            name: 'SettingsIntercom',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsIntercom.vue')
          }
        ]
      },
      {
        path: 'changelog',
        name: 'AdminChangelog',
        component: () => import(/* webpackChunkName: "changelog" */ '../views/admin/AdminChangelog.vue')
      },
      {
        path: 'changelog/create',
        name: 'ChangelogCreate',
        component: () => import(/* webpackChunkName: "changelog" */ '../views/admin/ChangelogCreate.vue')
      },
      {
        path: 'changelog/:changelogSlug',
        name: 'AdminChangelogDetail',
        component: () => import(/* webpackChunkName: "changelog" */ '../views/app/ChangelogDetail.vue')
      },
      {
        path: ':boardSlug',
        name: 'AdminBoard',
        meta: { member: true, board: true },
        component: () => import(/* webpackChunkName: "board" */ '../views/app/board/Board.vue')
      },
      {
        path: ':boardSlug/r/:featureSlug',
        name: 'AdminFeature',
        meta: { member: true, board: true },
        component: () => import(/* webpackChunkName: "feature" */ '../views/app/board/Feature.vue')
      },
      {
        path: ':boardSlug/settings',
        name: 'BoardSettings',
        component: () => import(/* webpackChunkName: "board" */ '../views/admin/board/Settings.vue'),
        children: [
          {
            path: '',
            name: 'BoardSettingsGeneral',
            component: () => import(/* webpackChunkName: "board" */ '../views/admin/board/BoardSettingsGeneral.vue')
          },
          {
            path: 'form',
            name: 'BoardSettingsForm',
            component: () => import(/* webpackChunkName: "board" */ '../views/admin/board/BoardSettingsForm.vue')
          },
          {
            path: 'widget',
            name: 'BoardSettingsWidget',
            component: () => import(/* webpackChunkName: "board" */ '../views/admin/board/BoardSettingsWidget.vue')
          },
          {
            path: 'import',
            name: 'BoardSettingsImport',
            component: () => import(/* webpackChunkName: "board" */ '../views/admin/board/BoardSettingsImport.vue')
          },
          {
            path: 'delete',
            name: 'BoardSettingsDelete',
            component: () => import(/* webpackChunkName: "board" */ '../views/admin/board/BoardSettingsDelete.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/',
    name: 'Public',
    beforeEnter: checkAuth,
    component: () => import(/* webpackChunkName: "public" */ '../views/Blank.vue'),
    children: [
      {
        path: '',
        name: 'MarketingLayout',
        component: () => import(/* webpackChunkName: "public" */ '../views/marketing/MarketingLayout.vue'),
        beforeEnter: systemOrCompany,
        children: [
          {
            path: 'login',
            name: 'login',
            component: () => import(/* webpackChunkName: "public" */ '../views/auth/Login.vue')
          },
          {
            path: 'register',
            name: 'register',
            component: () => import(/* webpackChunkName: "public" */ '../views/auth/Register.vue')
          },
          {
            path: 'verify/:token?',
            name: 'Verify',
            component: () => import(/* webpackChunkName: "public" */ '../views/auth/Verify.vue')
          },
          {
            path: 'forgot-password',
            name: 'ForgotPassword',
            component: () => import(/* webpackChunkName: "public" */ '../views/auth/ForgotPassword.vue')
          },
          {
            path: 'reset-password/:token?',
            name: 'ResetPassword',
            component: () => import(/* webpackChunkName: "public" */ '../views/auth/ResetPassword.vue')
          },
          {
            path: 'invite/:token',
            name: 'AcceptInvite',
            component: () => import(/* webpackChunkName: "public" */ '../views/auth/AcceptInvite.vue')
          },
          {
            path: 'oauth/loading/:provider',
            props: true,
            component: () => import(/* webpackChunkName: 'oauth' */ '../views/auth/OAuthLoading.vue')
          },
          {
            path: 'auth/:provider/callback',
            component: () => import(/* webpackChunkName: 'oauth' */ '../views/auth/OAuthSuccessCallback.vue')
          },
          {
            path: 'oauth/callback/success',
            component: () => import(/* webpackChunkName: 'oauth' */ '../views/auth/OAuthSuccessCallback.vue')
          },
          {
            path: 'oauth/callback/failure',
            component: () => import(/* webpackChunkName: 'oauth' */ '../views/auth/OAuthFailureCallback.vue')
          },
          {
            path: 'api/integration/slack/callback',
            name: 'SettingsSlackCallback',
            component: () => import(/* webpackChunkName: "integration" */ '../views/api/integration/SettingsSlackCallback.vue')
          },
          {
            path: 'api/integration/intercom/callback',
            name: 'SettingsIntercomCallback',
            component: () => import(/* webpackChunkName: "integration" */ '../views/api/integration/SettingsIntercomCallback.vue')
          }
        ]
      },
      {
        path: '',
        component: Company,
        children: [
          {
            path: '',
            name: 'PublicDashboard',
            component: () => import(/* webpackChunkName: "public" */ '../views/app/PublicDashboard.vue')
          },
          {
            path: 'changelog',
            name: 'PublicChangelog',
            component: () => import(/* webpackChunkName: "public" */ '../views/app/PublicChangelog.vue')
          },
          {
            path: 'changelog/:changelogSlug',
            name: 'PublicChangelogDetail',
            component: () => import(/* webpackChunkName: "public" */ '../views/app/ChangelogDetail.vue')
          },
          {
            path: 'settings',
            name: 'UserSettings',
            component: () => import(/* webpackChunkName: "settings" */ '../views/user/UserSettingsLayout.vue'),
            children: [
              {
                path: '',
                name: 'UserSettingsAccount',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsAccount.vue')
              },
              {
                path: 'change-password',
                name: 'UserSettingsChangePassword',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/SettingsChangePassword.vue')
              }
            ]
          },
          {
            path: ':boardSlug',
            name: 'PublicBoard',
            meta: { board: true },
            component: () => import(/* webpackChunkName: "board" */ '../views/app/board/Board.vue')
          },
          {
            path: ':boardSlug/r/:featureSlug',
            name: 'PublicFeature',
            meta: { board: true },
            component: () => import(/* webpackChunkName: "feature" */ '../views/app/board/Feature.vue')
          },
          {
            path: ':boardSlug/create',
            name: 'CreateFeature',
            meta: { board: true },
            component: () => import(/* webpackChunkName: "board" */ '../views/app/board/CreateFeature.vue')
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log('beforeEach: to -', to.name)
  const company = store.state.company
  if (to.path.substr(0, 6) === '/admin') {
    window.drift.show()
    if (to.path !== '/admin/settings/billing' && company && company.isExpired) {
      return next('/admin/settings/billing')
    } else next()
  } else {
    window.drift.hide()
    next()
  }
})

export default router
